import { handleActions, combineActions } from 'redux-actions';
import { combineReducers } from 'redux';
import * as actionTypes from '../constants';

export const isLoading = handleActions(
  {
    [actionTypes.SEARCH_BY_TYPE_REQUEST]: () => true,
    [actionTypes.SEARCH_BY_TYPE_SUCCESS]: () => false,
    [actionTypes.SEARCH_BY_TYPE_FAILURE]: () => false,
  },
  false,
);

export const results = handleActions(
  {
    [actionTypes.SEARCH_BY_TYPE_REQUEST]: () => ({}),
    [actionTypes.SEARCH_BY_TYPE_SUCCESS]: (state, action) => action.payload.results,
  },
  {},
);

export const error = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.SEARCH_BY_TYPE_REQUEST,
      actionTypes.SEARCH_BY_TYPE_SUCCESS,
    )]: () => ({}),
    [actionTypes.SEARCH_BY_TYPE_FAILURE]: (state, { payload }) => payload.error,
  },
  {},
);

export const shouldRefetch = handleActions(
  {
    [actionTypes.SHOULD_REFETCH]: (state, action) => action.payload,
  },
  false,
);

export const activePage = handleActions(
  {
    [actionTypes.SEARCH_BY_TYPE_REQUEST]: () => 1,
    [actionTypes.SEARCH_BY_TYPE_SUCCESS]: (state, action) => +action.payload.activePage,
  },
  1,
);

export default combineReducers({
  isLoading,
  results,
  error,
  activePage,
  shouldRefetch,
});
